<template>
  <div>
    <hero>
      <div class="uk-inline uk-light" slot="left">
        <h1 class="uk-heading-medium">Simple.<br>Reliable.<br>Affordable.</h1>
        <p class="uk-text-justify">High performance virtual private servers with a simple control panel, data encryption, and flat pricing.</p>
      </div>
      <div class="uk-card uk-card-default uk-text-center" slot="right">

        <div class="uk-card-header">
          <h3 class="uk-card-title">Deploy your VM</h3>
        </div>

        <div class="uk-card-body uk-margin-small-bottom uk-padding-remove-top">
          <form class="uk-grid-medium" uk-grid @submit.prevent="register">

            <div class="uk-width-1-1">
              <input class="uk-input ba-input" type="text" placeholder="Full Name" pattern="[-a-zA-Z']+\s[-a-zA-Z']+" title="Please input your first name and last name separated by a space" required v-model="user.fullname">
            </div>

            <div class="uk-width-1-1">
              <input class="uk-input ba-input" type="email" placeholder="Email Address" required v-model.trim="user.email">
            </div>

            <div class="uk-width-1-1">
              <input class="uk-input ba-input" type="password" placeholder="Create password" minlength="8" maxlength="20" title="Please specify a password between 8 and 20 characters." required v-model="user.password">
            </div>

            <div class="uk-width-1-1 uk-margin-top uk-flex">
              <label class="uk-text-small uk-flex-left"><input class="uk-checkbox" type="checkbox" required title="Acceptance of our Terms and Privacy Policy is required to create an account"> I accept the <a href="#terms" uk-toggle>Terms</a> and <a href="#privacy" uk-toggle>Privacy Policy</a></label>
            </div>

            <div class="uk-width-1-1 uk-margin-top">
              <input type="submit" class="uk-button uk-button-large ba-button-cta uk-width-1-1" value="Create Account">
            </div>

          </form>
        </div>
      </div>
    </hero>

    <features :features="vm.features" color="tertiary" />

    <testimonials />

    <features :features="business.features" :title="business.title" :subtitle="business.subtitle" color="tertiary" />
  </div>
</template>

<script>
import API from '@/store/axios.js'
import UIkit from 'uikit'
import { Promise } from 'bluebird'

export default {
	name: 'home',
	components: {
		features: () => import('@/components/home/features.vue'),
		hero: () => import('@/components/home/hero.vue'),
		testimonials: () => import('@/components/home/testimonials.vue')
	},
  data () {
    return {
      user: {
        fullname: '',
        email: '',
        password: ''
      },
      error: '',
      success: '',
      vm: {
        features: [
          {
            title: 'No limitations',
            description: 'Need kernel access? No problem! With our virtual machines there are no restrictions. Enjoy the benefits of having a server without the headache of maintaining the hardware.',
            link: {
              name: 'Specs',
              to: 'VM'
            }
          },
          {
            title: 'Effortless resizing',
            description: 'Resize your machine on-the-fly in just a few clicks. There is no need for shutting down or restarting your machine.',
            link: {
              name: 'Portal',
              to: 'Home'
            }
          },
          {
            title: 'Simple control panel',
            description: 'Our control panel makes managing your virtual machine as simple as possible. No marketing terms. No certification required.',
            link: {
              name: 'Portal',
              to: 'Home'
            }
          },
          {
            title: 'Obvious pricing',
            description: "No need to worry about hidden fees, uptime, or number of read/writes. What you see is what you're charged.",
            link: {
              name: 'Pricing',
              to: 'VM'
            }
          }
        ]
      },
      business: {
        title: 'Best of both worlds',
        subtitle: 'Small business feel — Big business reliability',
        features: [
          {
            title: 'World-class support',
            description: 'Free technical support 24/7/365 in multiple languages. Anytime you need us we are just a click away. Give us a shout!'
          },
          {
            title: 'Money-back guarantee',
            description: 'Our services are awesome and we know it! If you are unhappy with our services within your first 7 days, we will fully refund your payment.'
          },
          {
            title: 'High availability',
            description: 'Our servers are protected by multiple levels of redundancy, including redundant PDUs, distributed systems, and generator backups, which ensure 99% uptime.'
          },
          {
            title: 'Extreme flexibility',
            description: 'Have a custom request or order? We can fulfill even the most detailed requirements – thanks to the agility of our team and infrastructure.'
          }
        ]
      }
    }
  },
  methods: {
    register () {
      return Promise.try(() => {
        // reset our data in case they give it another shot
        this.error = ''
        this.success = ''

        var fnamesplit = this.user.fullname.split(' ')
        return API.post('users', {
          first_name: fnamesplit[0],
          last_name: fnamesplit[1],
          email: this.user.email,
          new_password: this.user.password,
          confirm_password: this.user.password
        }).then(() => {
          this.success = 'Successfully created account'
          this.showAlert()
          setTimeout(() => { // after 3 seconds redirect to login
            window.location.href = 'https://portal.bitaccel.com/login'
          }, 3000)
        }).catch((error) => {
          if (error.response.status === 409) {
            this.error = 'Email already exists'
            this.showAlert()
          } else {
            this.error = 'Internal server error. Please try again.'
            this.showAlert()
          }
        })
      })
    },
    showAlert () {
      UIkit.notification({
        message: this.error ? this.error : this.success,
        status: this.error ? 'danger' : 'success',
        pos: 'top-center',
        timeout: 3000
      })
    }
  },
	metaInfo: {
		meta: [
			{ name: 'description', content: 'BitAccel offers simple, reliable, and affordable cloud services, including virtual private servers, dedicated servers, and cloud storage.' }
		]
	}
}
</script>

<style scoped lang="less">
</style>
